import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="container-x py-16">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <div className="space-y-6">
          <p className="text-xs font-bold uppercase tracking-widest text-amber-600">About us</p>
          <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl" data-testid="about-title">About BMI SP GROUP</h1>
          <p className="leading-relaxed text-slate-600">
            BMI SP GROUP offers household cleaning products — detergent powder, floor cleaner / phenyl, toilet cleaner, hand wash and dish wash — and recruits people for sales, office, supervision and customer-relationship roles.
          </p>
          <p className="leading-relaxed text-slate-600">[Company story, founding year and registered details — to be provided by BMI SP GROUP. We do not publish registration numbers, approvals or certifications that have not been supplied.]</p>
          <div className="flex gap-3">
            <Link to="/careers" className="rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-amber-600" data-testid="about-careers-link">Careers</Link>
            <Link to="/products" className="rounded-full border border-slate-300 px-5 py-2.5 text-sm font-semibold hover:bg-slate-100" data-testid="about-products-link">Products</Link>
          </div>
        </div>
        <img src="/images/office.jpg" alt="Team at work" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-xl" />
      </div>
    </div>
  );
}
